import { render, staticRenderFns } from "./HostingPagesSidebar.vue?vue&type=template&id=26eb8a64&scoped=true"
import script from "./HostingPagesSidebar.vue?vue&type=script&lang=js"
export * from "./HostingPagesSidebar.vue?vue&type=script&lang=js"
import style0 from "./HostingPagesSidebar.scss?vue&type=style&index=0&id=26eb8a64&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26eb8a64",
  null
  
)

export default component.exports